import { render, staticRenderFns } from "./table.vue?vue&type=template&id=61f1ee5c"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f1ee5c')) {
      api.createRecord('61f1ee5c', component.options)
    } else {
      api.reload('61f1ee5c', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=61f1ee5c", function () {
      api.rerender('61f1ee5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list-note/table.vue"
export default component.exports